module.exports = __webpack_public_path__ + "static/media/adidas.79f17773.png";